import {combineReducers} from 'redux'

import therapiesReducer from './therapies'
import authReducer from './auth'
import patientsReducer from "./patients";
import reportsReducer from "./reports";

const cmkApp = combineReducers({
    'cmk': therapiesReducer,
    'auth': authReducer,
    'patients': patientsReducer,
    'reports' : reportsReducer
});

export default cmkApp


// WEBPACK FOOTER //
// ./src/store/reducers/index.js